class FloatingCartButton extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.link = this.querySelector('.floating-cart-button__circle');

    this.link.addEventListener('click', this.onClick.bind(this));
    document.addEventListener('cart-fetch-update', this.onCartUpdate.bind(this));
  }

  onClick(event) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    event.preventDefault();
    cartDrawer.open(this.link);
  }

  onCartUpdate(event) {
    if (event.detail !== 'updated') return;

    fetch(`${window.location.pathname}?sections=${this.sectionId}`)
      .then((response) => response.json())
      .then((sections) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(sections[this.sectionId], 'text/html');
        const newCircle = doc.querySelector('.floating-cart-button__circle');
        if (newCircle) this.link.innerHTML = newCircle.innerHTML;
      })
      .catch((error) => console.error('Error refreshing floating cart button:', error));
  }
}

customElements.define('floating-cart-button', FloatingCartButton);
